import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ParticleField } from "../effects/ParticleField";
import { Reveal } from "../Reveal";
import { CONTACT } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const ContactCTA = () => {
  const { t } = useLang();
  return (
    <section data-testid="contact-cta-section" className="relative overflow-hidden py-28 md:py-40 border-t border-white/5">
      <div className="absolute inset-0">
        <ParticleField density={60} />
      </div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[36vw] w-[36vw] rounded-full bg-[#3B82F6]/20 blur-[130px] animate-breathe pointer-events-none" />
      <div className="absolute left-[55%] top-[45%] h-[16vw] w-[16vw] rounded-full bg-[#F59E0B]/15 blur-[100px] animate-breathe pointer-events-none" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 md:px-12 text-center">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.28em] uppercase text-[#60A5FA]">{t(CONTACT.overline)}</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 text-4xl sm:text-6xl md:text-7xl font-medium tracking-tighter text-white text-balance leading-[1.02]">
            {t(CONTACT.title)}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 mx-auto max-w-xl text-lg text-white/55 leading-relaxed">{t(CONTACT.sub)}</p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="contact-cta-button"
              className="group inline-flex items-center gap-2 rounded-full bg-[#3B82F6] px-8 py-4 text-base font-medium text-white transition-all duration-300 shadow-[0_0_35px_rgba(59,130,246,0.45)] hover:shadow-[0_0_55px_rgba(59,130,246,0.75)] hover:bg-[#60A5FA] active:scale-[0.98]"
            >
              {t(CONTACT.cta)}
              <ArrowRight className="h-4.5 w-4.5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              data-testid="contact-cta-secondary"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur px-8 py-4 text-base font-medium text-white transition-all duration-300 hover:bg-white/10 hover:border-white/30 active:scale-[0.98]"
            >
              {t(CONTACT.cta2)}
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-6 text-sm text-white/35">{t(CONTACT.helper)}</p>
        </Reveal>
      </div>
    </section>
  );
};
